export const PAGES_ENDPOINTS = {
  GET_STARTED: '/getstarted',
  GET_STARTED_BASIC: '/getstarted?package=basic',
  GET_STARTED_ALL_INCLUSIVE: '/getstarted?package=all-inclusive',
  GET_STARTED_EXPERT: '/getstarted?package=expert',

  SWITCH: '/switch',
  AIR_CORPORATE: '/corporate',
  ACCOUNTING_SERVICES: '/accounting',
  ABOUT_US: '/about',
  BLOG: '/blog',
  TERMS_CONDITIONS: '/terms-conditions',
  PRIVACY_POLICY: '/privacy-policy',
  THANK_YOU: '/thank-you'
};
